<template>
  <div class="partner_set">
     <div class="banner_wrapper">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>{{$t('setting.crumbs.L1')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('setting.crumbs.L5')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="panel partner_account_setting">
      <div class="panel-header panel-header__fix">
        <div class="panel-select-group">
          <span class="panel-header__desc">{{$t('setting.crumbs.L5')}}</span>
        </div>
      </div>
      <!-- 搜索条件表单 -->
      <el-form ref="form" :model="form" :rules="formRules" label-width="170px" class="form partner_account_setting_form1">
        <el-form-item :label="$t('setting.form.account')" prop="account" class="form_account">
          <el-input v-model="form.account" v-if="role.single" disabled></el-input>
          <el-input v-model="form.account" v-else></el-input>
        </el-form-item>

        <el-form-item :label="$t('setting.form.gateway')">
          <el-select v-model="form.gateway" :placeholder="$t('setting.msg.m18')" @change="resetForm">
            <el-option v-for="(item, index) in gatewayList" :key="index" :label="item.name" :value="item.val"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="">
          <el-button type="primary" icon="search" class="btn" @click="getInfo" :loading="isInfoLoading"></el-button>
        </el-form-item>
      </el-form>
      <!-- 查询信息表单 -->
      <template v-if="gatewayType === 'payMe'">
      <el-form ref="accountForm" :model="accountForm" label-width="170px" class="account_form partner_account_setting_form2" :rules="rules" v-if="isEdit && isBtnClick">
        <el-form-item :label="$t('setting.form.clientID')" prop="client_id">
          <el-input v-model="accountForm.client_id"></el-input>
        </el-form-item>

        <el-form-item :label="$t('setting.form.clientSecret')" prop="client_secret">
          <el-input v-model="accountForm.client_secret"></el-input>
        </el-form-item>

        <el-form-item :label="$t('setting.form.signingKeyID')" prop="sign_key_id">
          <el-input v-model="accountForm.sign_key_id"></el-input>
        </el-form-item>

        <el-form-item :label="$t('setting.form.signingKey')" prop="sign_key">
          <el-input v-model="accountForm.sign_key"></el-input>
        </el-form-item>

        <el-form-item :label="$t('setting.form.expiresDate')" prop="expire" class="expires-date">
          <el-date-picker
            v-model.trim="accountForm.expire"
            type="date"
            :editable="false"
            :clearable="false"
            :picker-options="pickerOptions">
          </el-date-picker>
          <h3 class="expire_date_style">{{ $t('setting.form.expiresMsg') }}</h3>
        </el-form-item>

        <el-form-item label="" class="footer_btn">
          <el-button class="btn save" v-if="!fullFilled">{{ $t('setting.btn.save') }}</el-button>
          <template v-if="fullFilled">
            <el-button type="success" class="btn" @click="saveMsg('accountForm', 'hsbc/set_cb_account')" :loading="isSaveLoading">{{ $t('setting.btn.save') }}</el-button>
            <el-button type="primary" class="btn cancel" @click="cancel" :loading="isSaveLoading">{{ $t('setting.btn.cancel') }}</el-button>
          </template>
        </el-form-item>
      </el-form>
      <!-- 非编辑模式下展示表单信息 -->
      <el-form :model="accountFormDisabled" label-width="170px" class="account_form partner_account_setting_form3" :rules="rules" v-if="!isEdit && isBtnClick">
        <el-form-item :label="$t('setting.form.clientID')" prop="client_id">
          <el-input v-model="accountFormDisabled.client_id" disabled></el-input>
        </el-form-item>

        <el-form-item :label="$t('setting.form.clientSecret')" prop="client_secret">
          <el-input v-model="accountFormDisabled.client_secret" disabled></el-input>
        </el-form-item>

        <el-form-item :label="$t('setting.form.signingKeyID')" prop="sign_key_id">
          <el-input v-model="accountFormDisabled.sign_key_id" disabled></el-input>
        </el-form-item>

        <el-form-item :label="$t('setting.form.signingKey')" prop="sign_key">
          <el-input v-model="accountFormDisabled.sign_key" disabled></el-input>
        </el-form-item>

        <el-form-item :label="$t('setting.form.expiresDate')" prop="expire" class="expires-date">
          <el-date-picker
            v-model.trim="accountFormDisabled.expire"
            type="date"
            :editable="false"
            :clearable="false"
            disabled>
          </el-date-picker>
          <h3 class="expire_date_style">{{ $t('setting.form.expiresMsg') }}</h3>
        </el-form-item>

        <el-form-item label="" class="footer_btn">
          <el-button type="primary" class="btn" @click="Edit">{{ $t('setting.btn.edit') }}</el-button>
          <!-- <p class="btn_msg">{{ $t('setting.msg.m12') }}</p> -->
        </el-form-item>
      </el-form>
      </template>
      <template v-if="gatewayType === 'shopify'">
        <!-- 查询表单 -->
        <el-form ref="shopifyForm" :model="shopifyForm" label-width="170px" class="account_form shopify_form partner_account_setting_form1" :rules="shopifyRules" v-if="isEdit && isBtnClick">
          <el-form-item :label="$t('setting.form.shopifyDefaultDomain')" prop="shop_domain" class="shopify-common">
            <el-input v-model="shopifyForm.shop_domain"></el-input>
            <h3 class="example_h3">{{$t('setting.form.example')}}</h3>
          </el-form-item>
          <el-form-item :label="$t('setting.form.apiCredential')" prop="access_token" class="shopify-common">
            <el-input v-model="shopifyForm.access_token"></el-input>
            <a :href="targetUrl" target="_blank">{{$t('setting.form.howToGet')}}</a>
          </el-form-item>
          <el-form-item label="" class="footer_btn">
            <el-button class="btn save" v-if="!shopifyFullFilled">{{ $t('setting.btn.save') }}</el-button>
            <template v-if="shopifyFullFilled">
              <el-button type="success" class="btn" @click="saveMsg('shopifyForm', 'shopify/custom_app/set_account')" :loading="isSaveLoading">{{ $t('setting.btn.save') }}</el-button>
              <el-button type="primary" class="btn cancel" @click="cancel" :loading="isSaveLoading">{{ $t('setting.btn.cancel') }}</el-button>
            </template>
          </el-form-item>
        </el-form>
        <!-- 非编辑模式下展示表单信息 -->
        <el-form :model="shopifyFormDisabled" label-width="170px" class="account_form shopify_form partner_account_setting_form1" v-if="!isEdit && isBtnClick">
          <el-form-item :label="$t('setting.form.shopifyDefaultDomain')" prop="shop_domain" class="shopify-common">
            <el-input v-model="shopifyFormDisabled.shop_domain" disabled></el-input>
            <h3 class="example_h3">{{$t('setting.form.example')}}</h3>
          </el-form-item>
          <el-form-item :label="$t('setting.form.apiCredential')" prop="access_token" class="shopify-common">
            <el-input v-model="shopifyFormDisabled.access_token" disabled></el-input>
            <a :href="targetUrl" target="_blank">{{$t('setting.form.howToGet')}}</a>
          </el-form-item>
          <el-form-item label="" class="footer_btn">
            <el-button type="primary" class="btn" @click="Edit">{{ $t('setting.btn.edit') }}</el-button>
          </el-form-item>
        </el-form>
      </template>
    </div>
  </div>
</template>

<script>
import Store from '../../common/js/store'
import axios from 'axios'
import config from 'config'
import qs from 'qs'
import { Base64 } from 'js-base64'
import { adjustDate } from '../../common/js/util'
export default {
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          const today = adjustDate(new Date())
          const futureYear = today.slice(0, 4) - 0 + 5
          const futureTime = new Date(futureYear + today.slice(4)).getTime()
          return time.getTime() > futureTime
        }
      },
      role: Store.get('role') || {},
      form: {
        account: '',
        gateway: 'PayMe HSBC Online'
      },
      gatewayType: 'payMe',
      isEdit: '',
      isBtnClick: false,
      isInfoLoading: false,
      isSaveLoading: false,
      accountForm: {
        client_id: '',
        client_secret: '',
        sign_key_id: '',
        sign_key: '',
        expire: '',
      },
      accountFormDisabled: {
        client_id: '',
        client_secret: '',
        sign_key_id: '',
        sign_key: '',
        expire: '',
      },
      shopifyForm: {
        shop_domain: '',
        access_token: '',
      },
      shopifyFormDisabled: {
        shop_domain: '',
        access_token: '',
      },
      targetUrl: 'https://help.shopify.com/en/manual/apps/custom-apps#get-the-api-credentials-for-a-custom-app',
      gatewayList: [
        {name: this.$t('setting.gatewayList.online'), val: 'PayMe HSBC Online'},
        {name: this.$t('setting.gatewayList.customApp'), val: 'Shopify Custom App'},
      ],
      formRules: {
        account: [
          { required: true, message: this.$t('setting.msg.m19'), trigger: 'blur' }
        ]
      },
      rules: {
        client_id: [
          { required: true, message: this.$t('setting.msg.m14'), trigger: 'blur' }
        ],
        client_secret: [
          { required: true, message: this.$t('setting.msg.m15'), trigger: 'blur' }
        ],
        sign_key_id: [
          { required: true, message: this.$t('setting.msg.m16'), trigger: 'blur' }
        ],
        sign_key: [
          { required: true, message: this.$t('setting.msg.m17'), trigger: 'blur' }
        ],
        expire: [
          { required: true, message: this.$t('setting.msg.m20') }
        ]
      },
      shopifyRules: {
        shop_domain: [
          { required: true, message: this.$t('setting.msg.m21'), trigger: 'blur' }
        ],
        access_token: [
          { required: true, message: this.$t('setting.msg.m22'), trigger: 'blur' }
        ],
      }
    }
  },
  created() {
    if (this.role.single) {
      this.form.account = sessionStorage.getItem('account_user')
    }
  },
  props: {
    shop: {
      type: Object
    }
  },
  computed: {
    fullFilled () {
      if (this.accountForm.client_id && this.accountForm.client_secret && this.accountForm.sign_key_id && this.accountForm.sign_key && this.accountForm.expire) {
        return true
      } else {
        return false
      }
    },
    shopifyFullFilled () {
      if (this.shopifyForm.shop_domain && this.shopifyForm.access_token) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    // 处理 payme key 相关信息
    dealPaymeMsg (data) {
      if ((data.data.client_id === '' && data.data.client_secret === '' && data.data.sign_key_id === '' && data.data.sign_key === '' && data.data.expire === '') || data.data.client_id === undefined) {
        let param = {
          client_id: '',
          client_secret: '',
          sign_key_id: '',
          sign_key: '',
          expire: '',
        }
        this.accountForm = param
        this.accountFormDisabled = param
        this.isEdit = true
        this.isBtnClick = true
      } else {
        // 统一处理加密数据
        let clientId, clientSecret, signKeyId, signKey, expiresDate
        clientId = this.getBase64Decode(data.data.client_id)
        clientSecret = this.getBase64Decode(data.data.client_secret)
        signKeyId = this.getBase64Decode(data.data.sign_key_id)
        signKey = this.getBase64Decode(data.data.sign_key)
        expiresDate = data.data.expire || ''
        // 非编辑模式下数据处理
        this.accountFormDisabled.client_id = this.getSecretInfo(clientId)
        this.accountFormDisabled.client_secret = this.getSecretInfo(clientSecret)
        this.accountFormDisabled.sign_key_id = this.getSecretInfo(signKeyId)
        this.accountFormDisabled.sign_key = this.getSecretInfo(signKey)
        this.accountFormDisabled.expire = expiresDate
        // 编辑模式下数据处理
        this.accountForm.client_id = clientId
        this.accountForm.client_secret = clientSecret
        this.accountForm.sign_key_id = signKeyId
        this.accountForm.sign_key = signKey
        this.accountForm.expire = expiresDate
        this.isEdit = false
        this.isBtnClick = true
      }
    },
    // 处理 shopify 相关信息
    dealShopifyMsg (data) {
      if ((data.data.shop_domain === '' && data.data.access_token === '') || data.data.shop_domain === undefined) {
        let param = {
          shop_domain: '',
          access_token: ''
        }
        this.shopifyForm = param
        this.shopifyFormDisabled = param
        this.isEdit = true
        this.isBtnClick = true
      } else {
        let shopDomain, accessToken
        shopDomain = this.getBase64Decode(data.data.shop_domain)
        accessToken = this.getBase64Decode(data.data.access_token)
        this.shopifyForm.shop_domain = shopDomain
        this.shopifyForm.access_token = accessToken
        this.shopifyFormDisabled.shop_domain = this.getSecretInfo(shopDomain)
        this.shopifyFormDisabled.access_token = this.getSecretInfo(accessToken)
        this.isEdit = false
        this.isBtnClick = true
      }
    },
    // 获取信息接口
    getInfo () {
      let url
      if (this.gatewayType === 'payMe') {
        url = 'hsbc/get_account_cb_info'
      } else if (this.gatewayType === 'shopify') {
        url = 'shopify/custom_app/get_account_info'
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.isInfoLoading = true
          axios.get(`${config.host}/merchant/third/${url}`, {
            params: {
              userid: this.form.account,
              gateway: this.form.gateway,
              format: 'cors'
            }
          }).then(res => {
            let data = res.data
            if (data.respcd === config.code.OK) {
              if (this.gatewayType === 'payMe') {
                this.dealPaymeMsg(data)
              } else if (this.gatewayType === 'shopify') {
                this.dealShopifyMsg(data)
              }
            } else {
              this.$message.error(data.resperr)
            }
            this.isInfoLoading = false
          })
        }
      })
    },
    getPaymeParams () {
      let clientId, clientSecret, signKeyId, signKey, expiresDate
      let encPassword1 = Math.random().toString(36).substr(2, 4) + 'b' // 4位整数
      let encPassword2 = Math.random().toString(36).substr(2, 4) + 'b' // 4位整数
      let encPassword3 = Math.random().toString(36).substr(2, 4) + 'b' // 4位整数
      let encPassword4 = Math.random().toString(36).substr(2, 4) + 'b' // 4位整数
      clientId = encPassword1 + Base64.encode(this.accountForm.client_id)
      clientSecret = encPassword2 + Base64.encode(this.accountForm.client_secret)
      signKeyId = encPassword3 + Base64.encode(this.accountForm.sign_key_id)
      signKey = encPassword4 + Base64.encode(this.accountForm.sign_key)
      expiresDate = this.accountForm.expire
      return {
        userid: this.form.account,
        gateway: this.form.gateway,
        client_id: clientId,
        client_secret: clientSecret,
        sign_key_id: signKeyId,
        sign_key: signKey,
        expire: adjustDate(expiresDate),
        format: 'cors'
      }
    },
    getShopifyParams () {
      let shopDomain = Math.random().toString(36).substr(2, 4) + 'b' + Base64.encode(this.shopifyForm.shop_domain)
      let accessToken = Math.random().toString(36).substr(2, 4) + 'b' + Base64.encode(this.shopifyForm.access_token)
      return {
        userid: this.form.account,
        gateway: this.form.gateway,
        shop_domain: shopDomain,
        access_token: accessToken,
        format: 'cors'
      }
    },
    // 提交数据
    saveMsg (form, url) {
      let params
      if (form === 'accountForm') {
        params = this.getPaymeParams()
      } else if (form === 'shopifyForm') {
        params = this.getShopifyParams()
      }
      if (this.isBtnClick) {
        this.$refs[`${form}`].validate((valid) => {
          if (valid) {
            this.isSaveLoading = true
            axios.post(`${config.host}/merchant/third/${url}`, qs.stringify(params)).then(res => {
              let data = res.data
              if (data.respcd === config.code.OK) {
                this.isEdit = false
                this.isBtnClick = true
                this.$message({
                  message: this.$t('setting.msg.m13'),
                  type: 'success'
                })
                this.getInfo()
              } else {
                this.$message.error(data.resperr)
              }
              this.isSaveLoading = false
            })
          }
        })
      }
    },
    // 点击编辑按钮
    Edit () {
      this.isBtnClick = true
      this.isEdit = true
    },
    resetForm () {
      this.isEdit = ''
      this.isBtnClick = false
      if (this.form.gateway === 'PayMe HSBC Online') {
        this.gatewayType = 'payMe'
      } else if (this.form.gateway === 'Shopify Custom App') {
        this.gatewayType = 'shopify'
      }
      
    },
    // 取消按钮
    cancel () {
      this.isBtnClick = true
      if (this.gatewayType === 'payMe') {
        this.cancelKeyMsg()
      } else if (this.gatewayType === 'shopify') {
        this.cancelShopifyMsg()
      }
    },
    cancelKeyMsg () {
      if (this.accountFormDisabled.client_id === '' && this.accountFormDisabled.client_secret === '' && this.accountFormDisabled.sign_key === '' && this.accountFormDisabled.sign_key_id === '' && this.accountFormDisabled.expire === '') {
        this.isEdit = true
        this.accountForm.client_id = ''
        this.accountForm.client_secret = ''
        this.accountForm.sign_key = ''
        this.accountForm.sign_key_id = ''
        this.accountForm.expire = ''
      } else {
        this.isEdit = false
      }
    },
    cancelShopifyMsg () {
      if (this.shopifyFormDisabled.shop_domain === '' && this.shopifyFormDisabled.access_token === '') {
        this.isEdit = true
        this.shopifyForm.shop_domain = ''
        this.shopifyForm.access_token = ''
      } else {
        this.isEdit = false
      }
    },
    // 掩码
    getSecretInfo (key) {
      if (key.length > 8) {
        let secrete = ''
        const indexValue = key.substr(0, 4)
        const lastIndexValue = key.slice(-4)
        for (let i = 0; i < key.length - 8; i++) {
          secrete = secrete + '*'
        }
        return indexValue + secrete + lastIndexValue
      } else {
        return key
      }
    },
    // 解密base64
    getBase64Decode (val) {
      if (value === '') return ''
      let value = val.substr(5)
      value = Base64.decode(value)
      return value
    }
  }
}
</script>

<style lang="scss">
.partner_account_setting_form1, .partner_account_setting_form3, .partner_account_setting_form2 {
  .el-input {
    height: 30px;
    width: 260px;
    .el-input__inner {
      height: 30px;
    }
  }
  .el-form-item.is-required .el-form-item__label {
    &:before {
      display: block !important;
    }
  }
  .el-form-item__error {
    width: 200px;
  }
}

.footer_btn {
  margin-top: 50px;
  width: 350px !important;
  .el-form-item__content {
    display: flex;
  }
}
.btn {
  width: 70px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    opacity: .8;
    color: white;
    border: none;
  }
}
.btn_msg {
  height: 30px;
  line-height: 30px !important;
  margin-left: 20px;
  color: #FE9B20;
}
.save {
  background: gray;
  border: 1px solid gray;
  color: #FFFFFF;
}
.cancel {
  margin-left: 30px !important;
}
.partner_account_setting {
  padding-bottom: 40px;
}
.partner_set {
  .form {
    margin-left: 30px;
  }
}
.form {
  margin-top: 30px;
  margin-left: 65px;
  .el-form-item {
    width: 273px;
    margin-bottom: 20px;
  }
}
.account_form {
  margin-left: 30px;
  .el-form-item {
    width: 415px;
    margin-bottom: 20px;
    .el-form-item__label {
      position: relative;
      &::before {
        content: '*';
        color: red;
        position: absolute;
        top: 21px;
        left: 0;
        transform: translate(0, -50%);
      }
    }
  }
  .shopify-common {
    width: 100%;
    .el-form-item__content {
      display: flex;
      align-items: center;
      .example_h3 {
        color: #FE9B20;
        margin-left: 10px;
      }
      a {
        color: #FE9B20;
        font-size: 14px;
        margin-left: 10px;
        text-decoration: underline;
      }
    }
  }
  .expires-date {
    // display: flex;
    width: 100%;
    .el-form-item__content {
      display: flex;
      align-items: center;
      .el-input {
        width: 130px;
      }
      h3 {
        margin-left: 10px;
      }
      .expire_date_style {
        white-space: nowrap;
        overflow-x: auto;
        margin-right: 10px;
      }
      .example_h3 {
        color: #FE9B20;
      }
      a {
        color: #FE9B20;
        font-size: 14px;
        margin-left: 15px;
        text-decoration: underline;
      }
    }
  }
}
.form_account {
  .el-form-item__label {
    position: relative;
    &::before {
      content: '*';
      color: red;
      position: absolute;
      top: 23px;
      left: 0;
      transform: translate(0, -50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// partnerAccountSetting.vue?c8086018